import React from 'react';
import { styled } from '@mui/material';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import { Colors } from 'library';
import { RModal, RModalFooter } from './RModal';
import { RPillButton } from './RPillButton';

interface RColorPickerModalProps {
    color: string;
    onChange: (color: string) => void;
    onClose: () => void;
}

export function RColorPickerModal({ color, onChange, onClose }: RColorPickerModalProps) {
    return (
        <RModal title="Choose Color" onClose={onClose} width={300}>
            <Wrapper>
                <HexColorPicker color={color} onChange={onChange} />
                <HexInputRow>
                    <HexPrefix>#</HexPrefix>
                    <StyledHexInput color={color} onChange={onChange} prefixed={false} />
                </HexInputRow>
            </Wrapper>
            <RModalFooter>
                <RPillButton variant="primary" onClick={onClose}>
                    Done
                </RPillButton>
            </RModalFooter>
        </RModal>
    );
}

const Wrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    '& .react-colorful': {
        width: '100%',
        height: 180,
        borderRadius: 8,
    },
    '& .react-colorful__saturation': {
        borderRadius: '8px 8px 0 0',
    },
    '& .react-colorful__hue': {
        height: 12,
        borderRadius: 6,
    },
    '& .react-colorful__pointer': {
        width: 18,
        height: 18,
    },
});

const HexInputRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 8,
    overflow: 'hidden',
});

const HexPrefix = styled('span')({
    padding: '8px 0 8px 12px',
    fontSize: 14,
    fontWeight: 600,
    color: Colors.mediumGrey,
});

const StyledHexInput = styled(HexColorInput)({
    flex: 1,
    padding: '8px 12px 8px 4px',
    fontSize: 14,
    fontWeight: 600,
    color: Colors.darkNavy,
    border: 'none',
    outline: 'none',
    textTransform: 'uppercase',
});
